const Application = {
    hireing_company: '',
    job_title: '',
    link: '',
    page: '',
    location: '',
    status: ''
}

export default Application;